// extracted by mini-css-extract-plugin
module.exports = {"column-empty-state":"_3xHVV___BuildingsTable-module__column-empty-state"};